import { Component, Input, OnDestroy, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import videojs from 'video.js';
import { ChecklistDetailsFileLinkWithThumbnail, DealerMediaResponse } from '../services/client.service';
import { VideoPlayerService } from '../services/video-player.service';


@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
  standalone: true,
  imports: []
})
export class VideoPlayerComponent implements OnChanges, AfterViewInit, OnDestroy {
  player: any;
  @Input() media!: ChecklistDetailsFileLinkWithThumbnail;
  @Input() introOutroMediaData!: DealerMediaResponse;
  combinedMedia: any[] = [];
  currentVideoIndex: number = 0;
  elementId: string = "";
  isFirstPlay: boolean = true;

  constructor(private videoPlayerService: VideoPlayerService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.media && this.introOutroMediaData) {
      const { intro, outro } = this.introOutroMediaData;
      this.combinedMedia = [
        ...(intro ? [intro] : []),
        this.media,
        ...(outro ? [outro] : [])
      ];
    }
    else if (this.media && !this.introOutroMediaData) {
      this.combinedMedia = [this.media];
    }
    this.elementId = "Id" + Math.random().toString(36).substring(2, 9) + this.media.id.toString();
  }

  ngAfterViewInit() {
    this.player = videojs(this.elementId, {
      controls: true,
      autoplay: false,
      preload: 'auto',
      controlBar: {
        durationDisplay: false,
        remainingTimeDisplay: false,
        volumePanel: true,
        progressControl: true,
        playToggle: true,
        fullscreenToggle: true
      }
    });
    this.setVideoSource();

    this.player.on('play', () => {
      if (this.isFirstPlay) {
        this.isFirstPlay = false;
      }
      if (this.currentVideoIndex === this.combinedMedia.length) {
        this.currentVideoIndex = 0;
        this.setVideoSource();
      }
      this.videoPlayerService.setActivePlayer(this.player);
    });

    this.player.on('ended', () => {
      this.playNextVideo();
    });
  }

  setVideoSource() {
    this.player.src(this.formatVideoObject(this.currentVideoIndex));
  }

  formatVideoObject(index: number) {
    let formatedType;
    if (this.combinedMedia[index]?.mimeType?.includes("Video")) {
      const mimeTypeObject = this.combinedMedia[index]?.mimeType?.split("Video_");
      formatedType = "video/" + mimeTypeObject[1];
    } else {
      formatedType = null;
    }

    return {
      type: formatedType || "video/mp4",
      src: this.combinedMedia[index].url
    };
  }

  playNextVideo() {
    if (this.currentVideoIndex < this.combinedMedia.length - 1) {
      this.currentVideoIndex++;
      this.setVideoSource();
      this.player.play();
    } else {
      this.currentVideoIndex = this.combinedMedia.length;
      this.player.pause();
    }
  }

  resetVideoIndex(replay: boolean = false): void {
    if (replay) {
      this.currentVideoIndex = 0;
      this.isFirstPlay = true;

      this.player.pause();
      this.player.currentTime(0);
      
      this.setVideoSource();
    }
  }

  ngOnDestroy() {
    if (this.player) {
      this.videoPlayerService.clearActivePlayer(this.player);
      this.player.dispose();
    }
  }
}
